import isEqual from 'lodash/isEqual';

import { iaRa, mString } from 'lib/helpers/utility';

import { CPT_CODE_OPTIONS } from 'components/shared/Filters/lib/filterOptions';

import ServiceActions from '../components/ServiceActions';

export const servicesColumns = [
  {
    headerName: '',
    field: '',
    maxWidth: 40,
    headerCheckboxSelection: true,
    checkboxSelection: (params) => !params.node.group
  },
  {
    field: 'name',
    headerName: 'Name',
    sortable: false
  },
  {
    field: 'professionGroups',
    headerName: 'Specialty',
    sortable: false,
    cellRenderer: ({ value }) =>
      iaRa(value)
        .map((v) => v.name)
        .join(', ')
  },
  {
    field: 'total_cost_cents',
    headerName: 'Self pay',
    cellRenderer: ({ value }) => mString(value),
    sortable: false
  },
  {
    field: 'par_amount',
    headerName: 'Allowable amount',
    cellRenderer: ({ value }) => mString(value)
  },
  {
    field: 'standard_charge',
    headerName: 'Standard',
    cellRenderer: ({ value }) => mString(value),
    sortable: false
  },
  {
    field: 'actions',
    headerName: 'Actions',
    cellRenderer: ServiceActions,
    maxWidth: 100,
    minWidth: 36,
    resizable: false,
    sortable: false,
    pinned: 'right'
  }
];

export const scheduleOfFeesMainColumns = [
  {
    field: 'name',
    headerName: 'Name',
    sortable: false,
    flex: 1,
    headerCheckboxSelection: true,
    checkboxSelection: (params) => !params.node.group
  },
  {
    field: 'professionGroups',
    headerName: 'Specialty',
    sortable: false,
    cellRenderer: ({ value }) =>
      iaRa(value)
        .map((v) => v.name)
        .join(', '),
    flex: 1
  },
  {
    field: 'total_cost_cents',
    headerName: 'Self pay',
    cellRenderer: ({ value }) => mString(value),
    sortable: false,
    maxWidth: 120
  },
  {
    field: 'par_amount',
    headerName: 'Allowable amount',
    cellRenderer: ({ value }) => mString(value),
    maxWidth: 150
  },
  {
    field: 'standard_charge',
    headerName: 'Standard',
    cellRenderer: ({ value }) => mString(value),
    sortable: false,
    maxWidth: 120
  },
  {
    field: 'actions',
    headerName: 'Actions',
    cellRenderer: ServiceActions,
    maxWidth: 100,
    minWidth: 36,
    resizable: false,
    sortable: false,
    pinned: 'right'
  }
];

export const defaultFilters = () => ({
  name: {
    title: 'Name',
    placeholder: 'Search name',
    allowed_operators: ['contains', 'does not contain'],
    icon: 'first-line-mono'
  },
  description: {
    title: 'Description',
    allowed_operators: ['contains', 'does not contain'],
    icon: 'file-text-mono'
  },
  procedure_code: {
    ...CPT_CODE_OPTIONS,
    title: 'Procedure code'
  }
});

export const defaultColumns = () => [
  {
    field: 'name',
    headerName: 'Name',
    tooltipField: 'name',
    cellClass: 'no-border',
    flex: 1
  },
  {
    field: 'description',
    cellClass: 'no-border',
    headerName: 'Description',
    tooltipField: 'description',
    flex: 1
  },
  {
    field: 'procedure_code',
    headerName: 'Procedure code',
    cellClass: 'no-border',
    flex: 1
  },
  {
    field: 'time_length',
    headerName: 'Time length',
    cellClass: 'no-border',
    flex: 1
  },
  {
    field: 'total_cost_cents',
    headerName: 'Self pay amt.',
    cellClass: 'no-border',
    flex: 1,
    valueFormatter: ({ value }) => mString(value)
  },
  {
    field: 'standard_charge',
    headerName: 'Standard charge',
    cellClass: 'no-border',
    flex: 1,
    valueFormatter: ({ value }) => mString(value)
  },
  {
    field: 'cpt.par_amount',
    headerName: 'Medicare allowable amt.',
    cellClass: 'no-border',
    flex: 1,
    valueFormatter: ({ value }) => mString(value)
  }
];

/**
 * @param {Object} updatedService - The updated service object.
 * @param {Object} service - The original service object.
 * @returns {Object} - An object containing the changes.
 */
export const getServiceChanges = (updatedService, service) => {
  const serviceChanges = {};
  for (const key in updatedService) {
    if (!isEqual(updatedService[key], service[key])) {
      serviceChanges[key] = updatedService[key];
    }
  }
  return serviceChanges;
};
